<template>
  <v-dialog
    v-model="threadDumpDialog"
    persistent
    width="500"
  >
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip
        top
        color="primary"
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
          >
            <v-icon>mdi-spider-thread</v-icon>
          </v-btn>
        </template>
        <span>Thread Dump</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        Generate Thread Dump
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="text-center"
            >
              <v-form
                ref="threaddumpform"
                lazy-validation
              >
                <v-select
                  v-model="selectedService"
                  :items="services"
                  :rules="[rules.required]"
                  label="Service"
                />
                <v-text-field
                  v-model="reference"
                  :rules="[rules.required, rules.reference]"
                  label="Reference"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="threadDumpDialog = false"
        >
          CANCEL
        </v-btn>
        <v-btn
          color="accent"
          @click="confirmServiceAction"
        >
          CONFIRM
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'ThreadDumpDialog',
    props: {
      contractName: String,
      contractNumber: String,
      server: Object,
    },
    data () {
      return {
        selectedService: '',
        selectedAction: '',
        reference: '',
        threadDumpDialog: false,
        actions: ['start', 'restart', 'stop'],
        rules: {
          required: value => !!value || 'Required.',
          reference: value => {
            const pattern = /^[rstRST]?[0-9]{6,}$/
            if (value) {
              return pattern.test(value) || 'Invalid Reference.'
            } else {
              return true
            }
          },
        },
      }
    },
    computed: {
      services () {
        let serviceArray = []
        switch (this.server.server_type) {
          case 'WEB':
            serviceArray = ['assyst']
            break
          case 'CSR':
            if (this.server.reports === 'y') {
              serviceArray.push('reports')
            }
            if (this.server.chat === 'y') {
              serviceArray.push('chat')
            }
            if (this.server.search === 'y') {
              serviceArray.push('search')
            }
            break
          case 'IMQ':
            if (this.server.ipaas === 'y') {
              serviceArray.push('ipaas')
            }
            if (this.server.activemq === 'y') {
              serviceArray.push('activemq')
            }
            break
        }
        return serviceArray
      },
      serviceObject () {
        return {
          data: {
            server_ip: this.server.private_ip_address,
            server_name: this.server.Name,
            service_name: this.selectedService,
            customer: this.contractName,
            contract: this.contractNumber,
            reference: this.reference,
          },
        }
      },
    },
    created () {
      this.selectedService = this.services[0]
    },
    methods: {
      confirmServiceAction: function () {
        if (this.$refs.threaddumpform.validate()) {
          this.threadDumpDialog = false
          // console.log(this.serviceObject)
          this.$emit('downloadThreadDump', this.serviceObject)
        }
      },
    },
  }
</script>
